// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

const UserSettings: React.LazyExoticComponent<any> = React.lazy(() => import('./Container'));

export default class Loader extends TabLoader {
  /* Override tab loader method */
  public loadTab = (): void => {
    window.store.dispatch(removeAll());

    const tabData: TabConfig = {
      id: window.getStr(),
      title: 'My Account',
      active: true,
      component: UserSettings,
    };

    window.store.dispatch(addTab(tabData));
  };
}
